import { loan_request } from '@axo/shared/data-access/types';

export interface ILenderFilterParams {
  loanRequest?: Omit<loan_request.CreateLoanRequest, 'LenderID'>;
  lenderIDs?: string[];
}

export const lenderFilterKeys = {
  root: (params: ILenderFilterParams) =>
    ['lender', params.loanRequest, params.lenderIDs] as const,
};

export function parseLenderFilterKey<T extends keyof typeof lenderFilterKeys>(
  queryKey: ReturnType<(typeof lenderFilterKeys)[T]>,
) {
  const [, loanRequest, lenderIDs] = queryKey;

  return { loanRequest, lenderIDs };
}
